var map = {
	"./access.svg": "81aa",
	"./alarm.svg": "bc34",
	"./certificate.svg": "affe",
	"./chat.svg": "07c7",
	"./devices.svg": "fcde",
	"./download.svg": "c06e",
	"./faq.svg": "a0a3",
	"./id.svg": "2cc8",
	"./list.svg": "e35d",
	"./live.svg": "ab7d",
	"./material.svg": "c56e",
	"./moderator.svg": "981b",
	"./repeat.svg": "b282",
	"./shoppinglist.svg": "0116",
	"./star.svg": "ed7f",
	"./trophy.svg": "b945",
	"./video.svg": "1442"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2b51";